var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 10.0003L9.16699 11.667L12.917 7.91699M6.1118 3.18257C6.78166 3.12912 7.41759 2.86571 7.92905 2.42984C9.1226 1.41271 10.8781 1.41271 12.0716 2.42984C12.5831 2.86571 13.219 3.12912 13.8889 3.18257C15.452 3.30731 16.6933 4.54861 16.8181 6.1118C16.8715 6.78166 17.1349 7.41759 17.5708 7.92905C18.5879 9.1226 18.5879 10.8781 17.5708 12.0716C17.1349 12.5831 16.8715 13.219 16.8181 13.8889C16.6933 15.452 15.452 16.6933 13.8889 16.8181C13.219 16.8715 12.5831 17.1349 12.0716 17.5708C10.8781 18.5879 9.1226 18.5879 7.92905 17.5708C7.41759 17.1349 6.78166 16.8715 6.1118 16.8181C4.54861 16.6933 3.30731 15.452 3.18257 13.8889C3.12912 13.219 2.86571 12.5831 2.42984 12.0716C1.41271 10.8781 1.41271 9.1226 2.42984 7.92905C2.86571 7.41759 3.12912 6.78166 3.18257 6.1118C3.30731 4.54861 4.54861 3.30731 6.1118 3.18257Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliant);
export default __webpack_public_path__ + "static/media/compliant.897744fc740c362dae4e6850efcd830e.svg";
export { ForwardRef as ReactComponent };